import { render, staticRenderFns } from "./PFSettlementPolicySlabs.vue?vue&type=template&id=4cf940ca"
import script from "./PFSettlementPolicySlabs.vue?vue&type=script&lang=js"
export * from "./PFSettlementPolicySlabs.vue?vue&type=script&lang=js"
import style0 from "./PFSettlementPolicySlabs.vue?vue&type=style&index=0&id=4cf940ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports